import { createI18n } from 'vue-i18n';

import 'moment/dist/locale/es';
import 'moment/dist/locale/it';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/ja';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/de';
import 'moment/dist/locale/th';
import 'moment/dist/locale/sv';

const env = import.meta.env || {};

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  // Locale JSON is loaded at app bootstrap; in Vitest many keys are missing until then.
  missingWarn: !env.VITEST,
  fallbackWarn: !env.VITEST,
});

export default i18n;
